import { StoresRepository } from '../repositories/StoresRepository';
import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/StoresService';
import { emit, events } from '@estee/elc-service-bus';
import { IMarker } from '~controllers/StoresMapViewController';
import { StoresMap } from '~domain/entities/StoresMap';

export class StoresMapMarkerClickedUseCase {
    private storesRepository: StoresRepository;
    private storesMap: StoresMap;

    constructor() {
        this.storesRepository = diContainer.get(serviceNames.storesRepository);
        this.storesMap = diContainer.get(serviceNames.storesMap);
    }

    public execute = async ({ id: storeId, position: { latitude, longitude } }: IMarker) => {
        this.storesRepository.setSelectedStoreId(storeId);
        emit(events.STORE_MARKER_CLICKED, { storeId });

        this.storesMap.updateMapCenter({
            lat: String(latitude),
            lng: String(longitude)
        });
    };
}
